/* istanbul ignore file */
import Badge from '../../mui-builder/Badge/Badge';
import { BadgeLayoutProps } from 'framework/ui/uiContract/uiContract';

const ActiveBadge = (props: BadgeLayoutProps) => {
  return (
    <Badge color="success" sx={{ ml: 1 }} {...props}>
      Active
    </Badge>
  );
};

export default ActiveBadge;
